/** Canonical origin for the public site, used to build absolute URLs for SEO metadata. */
export const SITE_URL = 'https://www.get-dash.com';

/** Falls back into og:image and twitter:image on pages that do not set one of their own. */
export const DEFAULT_OG_IMAGE = SITE_URL + '/assets/images/og-image.png';

/** Publisher/author for structured data. Matches the Organization node in index.html. */
export const ORGANIZATION_JSON_LD_ID = SITE_URL + '/#org';
export const ORGANIZATION_NAME = 'Apt Software Ltd';
